import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M13.576 17.346s3.34 4.166 3.397 3.166c.058-1 .173-3.277.173-3.277l.54-.01a2.667 2.667 0 0 0 2.618-2.785l-.252-5.618a3.333 3.333 0 0 0-3.341-3.184l-9.986.035a2.653 2.653 0 0 0-2.65 2.644c-.006 2.305 0 5.463.07 6.641 0 .722.576 1.333 1.267 1.444.46.056 5.142.486 3.588-1.902-1.992-1.403-4.423 3.459 1.161 3.848"
    />
    <path
      d="M9 12.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12.333 12.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2M15.667 12.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const ChatIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
